var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualitySupplyChainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 20.8333C26.6667 25 23.75 27.0833 20.2834 28.2916C20.1018 28.3531 19.9047 28.3502 19.725 28.2833C16.25 27.0833 13.3334 25 13.3334 20.8333V15C13.3334 14.779 13.4212 14.567 13.5775 14.4107C13.7337 14.2544 13.9457 14.1666 14.1667 14.1666C15.8334 14.1666 17.9167 13.1666 19.3667 11.9C19.5433 11.7491 19.7678 11.6663 20 11.6663C20.2322 11.6663 20.4568 11.7491 20.6334 11.9C22.0917 13.175 24.1667 14.1666 25.8334 14.1666C26.0544 14.1666 26.2663 14.2544 26.4226 14.4107C26.5789 14.567 26.6667 14.779 26.6667 15V20.8333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualitySupplyChainIcon);
export default __webpack_public_path__ + "static/media/Quality & Supply Chain-icon.07014ca7d937a3eeff2a9060aadf03aa.svg";
export { ForwardRef as ReactComponent };